module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/dot-circle.svg?0b8ea3bb45b3e61315a3813db9b534fe";